import { Box, Button, IconButton, Stack, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CloseIcon from '@mui/icons-material/Close'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'

const PromotionalAlert = () => {
  return (
    <Box
      sx={{
        width: { xl: '100%', lg: '100%', md: '95%', sm: '90%', xs: '91%' },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#5968C3',
        borderRadius: '8px',
        minHeight: '64px',
        maxHeight: '92px',
        px: 2,
        py: 1,
      }}
    >
      <Stack direction={'row'} columnGap={1} rowGap={1.2} flexWrap={'wrap'}>
        <InfoOutlinedIcon sx={{ color: '#fff' }} />
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: '400',
            color: ' #fff',
            textAlign: 'left',
          }}
        >
          New Final Expense Product Available in March
        </Typography>
      </Stack>
      <Stack direction={'row'} columnGap={1} rowGap={1.2} justifyContent={'flex-end'} flexWrap={'wrap-reverse'}>
        <Button
          variant="outlined"
          endIcon={<ArrowRightAltIcon />}
          sx={{
            fontSize: '14px',
            bgcolor: 'transparent',
            borderColor: '#fff',
            borderRadius: '100px',
            color: '#fff',
            textTransform: 'none',
            minWidth: '145px',
          }}
        >
          Get access
        </Button>
        <IconButton>
          <CloseIcon sx={{ color: '#fff', fontSize: '14px' }} />
        </IconButton>
      </Stack>
    </Box>
  )
}

export default PromotionalAlert
